import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-227cdaca")

_pushScopeId("data-v-227cdaca")
const _hoisted_1 = { class: "request-progress" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Chip = _resolveComponent("Chip")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("p", null, [
      _createVNode(_component_Chip, {
        class: _ctx.card.style
      }, {
        default: _withId(() => [
          _createTextVNode(_toDisplayString(_ctx.card.state), 1)
        ]),
        _: 1
      }, 8, ["class"])
    ])
  ]))
})